import { whoami_default } from "./whoami-Bz6QKirR.js";
import { find_organizations_default } from "./find-organizations-CXTZEMsb.js";
import { find_teams_default } from "./find-teams-ZsyAWNb7.js";
import { find_projects_default } from "./find-projects-BYeZfQDF.js";
import { find_releases_default } from "./find-releases-fkgr4qqZ.js";
import { get_release_details_default } from "./get-release-details-0bKoH-Gv.js";
import { find_dashboards_default } from "./find-dashboards-DE0x5cIv.js";
import { get_dashboard_details_default } from "./get-dashboard-details-7tf-4Q_F.js";
import { find_monitors_default } from "./find-monitors-DOaVdrCU.js";
import { get_monitor_details_default } from "./get-monitor-details-CP_Cj6P3.js";
import { find_uptime_monitors_default } from "./find-uptime-monitors-NZjkNLjM.js";
import { get_uptime_monitor_details_default } from "./get-uptime-monitor-details-DfFRiDqD.js";
import { create_uptime_monitor_default } from "./create-uptime-monitor-fo-rIhsm.js";
import { update_uptime_monitor_default } from "./update-uptime-monitor-CXyi5lFD.js";
import { delete_uptime_monitor_default } from "./delete-uptime-monitor-CHj4Cluv.js";
import { find_alert_rules_default } from "./find-alert-rules-Co9XjMKY.js";
import { get_alert_rule_default } from "./get-alert-rule-WfTdEa_v.js";
import { get_issue_details_default } from "./get-issue-details-DHDUffp5.js";
import { get_event_stacktrace_default } from "./get-event-stacktrace-ODRk7GSR.js";
import { get_issue_activity_default } from "./get-issue-activity-CKhQWy99.js";
import { get_issue_breadcrumbs_default } from "./get-issue-breadcrumbs-D5AeF8Vm.js";
import { get_issue_tag_values_default } from "./get-issue-tag-values-DtJZnl37.js";
import { get_issue_user_reports_default } from "./get-issue-user-reports-D73TLuX2.js";
import { get_trace_details_default } from "./get-trace-details-D7U8b5_V.js";
import { get_span_details_default } from "./get-span-details-DfXIT1v_.js";
import { get_replay_details_default } from "./get-replay-details-BWeEKq_j.js";
import { get_event_attachment_default } from "./get-event-attachment-h8oTTPZt.js";
import { update_issue_default } from "./update-issue-q9a5YNJb.js";
import { search_events_default } from "./search-events-C8aVtdIY.js";
import { create_team_default } from "./create-team-Bz1tSDLQ.js";
import { create_project_default } from "./create-project-CTQakq9G.js";
import { update_project_default } from "./update-project-BYY10KTt.js";
import { add_team_to_project_default } from "./add-team-to-project-DrTGc_T9.js";
import { remove_team_from_project_default } from "./remove-team-from-project-CT7eqBf7.js";
import { create_dsn_default } from "./create-dsn-C-kIpqG7.js";
import { find_dsns_default } from "./find-dsns-DCUQXIHr.js";
import { update_dsn_default } from "./update-dsn-Ce0IWsRx.js";
import { analyze_issue_with_seer_default } from "./analyze-issue-with-seer-Dy01BWPf.js";
import { search_docs_default } from "./search-docs-DVVQKCxP.js";
import { get_doc_default } from "./get-doc-CnSvhrTG.js";
import { search_issues_default } from "./search-issues-CQ0efOru.js";
import { search_issue_events_default } from "./search-issue-events-fYjr_r6r.js";
import { get_profile_default } from "./get-profile-CilEVKTg.js";
import { get_profile_details_default } from "./get-profile-details-B7TCia0B.js";
import { get_agent_conversation_details_default } from "./get-agent-conversation-details-DTJR8hFg.js";
import { get_snapshot_default } from "./get-snapshot-Ce1Z98WR.js";
import { get_snapshot_image_default } from "./get-snapshot-image-CWtW-DQz.js";
import { get_sentry_resource_default } from "./get-sentry-resource-DAx17Rhc.js";
import { get_latest_base_snapshot_default } from "./get-latest-base-snapshot-KoSAQyLF.js";
import { search_agent_conversations_default } from "./search-agent-conversations-CUhIOq09.js";
import { add_issue_note_default } from "./add-issue-note-DqTid9mJ.js";
import { onboarding_status_update_default } from "./onboarding-status-update-ZaTsL300.js";

//#region src/tools/catalog/index.ts
const legacyGetAIConversationDetails = {
	...get_agent_conversation_details_default,
	name: "get_ai_conversation_details",
	includeInSkillDefinitions: false,
	description: [
		"Deprecated alias for get_agent_conversation_details.",
		"",
		"Use get_agent_conversation_details for new integrations. This alias is kept for backward compatibility."
	].join("\n")
};
const legacySearchAIConversations = {
	...search_agent_conversations_default,
	name: "search_ai_conversations",
	includeInSkillDefinitions: false,
	description: [
		"Deprecated alias for search_agent_conversations.",
		"",
		"Use search_agent_conversations for new integrations. This alias is kept for backward compatibility."
	].join("\n")
};
/**
* Catalog of ordinary Sentry MCP operations.
*
* These tools are searchable/executable through search_sentry_tools and execute_sentry_tool.
* A central subset is also exposed directly via tools/list in surfaces.ts.
*
* Wrapper tools such as search_sentry_tools and execute_sentry_tool intentionally
* live outside this catalog.
*/
const catalogTools = {
	whoami: whoami_default,
	find_organizations: find_organizations_default,
	find_teams: find_teams_default,
	find_projects: find_projects_default,
	find_releases: find_releases_default,
	get_release_details: get_release_details_default,
	find_dashboards: find_dashboards_default,
	get_dashboard_details: get_dashboard_details_default,
	find_monitors: find_monitors_default,
	get_monitor_details: get_monitor_details_default,
	find_uptime_monitors: find_uptime_monitors_default,
	get_uptime_monitor_details: get_uptime_monitor_details_default,
	create_uptime_monitor: create_uptime_monitor_default,
	update_uptime_monitor: update_uptime_monitor_default,
	delete_uptime_monitor: delete_uptime_monitor_default,
	find_alert_rules: find_alert_rules_default,
	get_alert_rule: get_alert_rule_default,
	get_issue_details: get_issue_details_default,
	get_event_stacktrace: get_event_stacktrace_default,
	get_issue_activity: get_issue_activity_default,
	get_issue_breadcrumbs: get_issue_breadcrumbs_default,
	get_issue_user_reports: get_issue_user_reports_default,
	get_issue_tag_values: get_issue_tag_values_default,
	get_trace_details: get_trace_details_default,
	get_span_details: get_span_details_default,
	get_replay_details: get_replay_details_default,
	get_event_attachment: get_event_attachment_default,
	update_issue: update_issue_default,
	search_events: search_events_default,
	create_team: create_team_default,
	create_project: create_project_default,
	update_project: update_project_default,
	add_team_to_project: add_team_to_project_default,
	remove_team_from_project: remove_team_from_project_default,
	create_dsn: create_dsn_default,
	find_dsns: find_dsns_default,
	update_dsn: update_dsn_default,
	analyze_issue_with_seer: analyze_issue_with_seer_default,
	search_docs: search_docs_default,
	get_doc: get_doc_default,
	search_issues: search_issues_default,
	search_issue_events: search_issue_events_default,
	get_profile: get_profile_default,
	get_profile_details: get_profile_details_default,
	get_sentry_resource: get_sentry_resource_default,
	get_snapshot: get_snapshot_default,
	get_snapshot_image: get_snapshot_image_default,
	get_latest_base_snapshot: get_latest_base_snapshot_default,
	get_agent_conversation_details: get_agent_conversation_details_default,
	get_ai_conversation_details: legacyGetAIConversationDetails,
	search_agent_conversations: search_agent_conversations_default,
	search_ai_conversations: legacySearchAIConversations,
	add_issue_note: add_issue_note_default,
	onboarding_status_update: onboarding_status_update_default
};
var catalog_default = catalogTools;

//#endregion
export { catalog_default };
//# sourceMappingURL=catalog-DaTB1cy-.js.map